import config from 'config';
import Local from 'modules/Local';
import { getPublisher } from 'modules/Publisher';

export default () => ({
  ...(getPublisher()?.features || {}),
  ...config.features(Local.getEnvironmentId()),
});
